import React from "react";
import "./FormInput.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from "@fortawesome/free-solid-svg-icons";


const FormInput = ({ label, name, required, error, hiddenStar, isChild = false, type = 'text', ...rest }) => {
    return (
        <>
            <div className="forminput-formgroup">
                {label && (
                    <label className={isChild ? 'forminput-xs' : null}>
                        {label}
                        <span>
                            {(required && !hiddenStar) && <FontAwesomeIcon icon={faStar} />}
                        </span>
                    </label>)}
                <div className="forminput-required">
                    {/* {(required && !hiddenStar) && < FontAwesomeIcon icon={faStar} />} */}
                </div>
                <input className={`forminput ${error ? 'forminput-error' : ''}`}
                    type={type} {...rest} />
            </div>
            {(error && error !== "") && <div className="forminput-msg">{error}</div>
            }
        </>
    )
}

export default FormInput;